import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { useUser } from "../utils/UserContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins, faXmark, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash, faClock } from '@fortawesome/free-regular-svg-icons'
import { getCurrencySymbol, getRate } from '../utils/currencyUtils';

function Mining() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [miningBar, setMiningBar] = useState(false);
  const toggleMiningBar = () => {
    setMiningBar(!miningBar);
  };
  const [see, setSee] = useState(true);
  const [minbal, setMinbal] = useState(0);
  const [activemining, setActivemining] = useState([
  ]);
  const [closedmining, setClosedmining] = useState([
  ]);
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Mining" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Mining" icon={<FontAwesomeIcon icon={faCoins} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="mycard mt-2">
                  <div className="d-md-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center flex-wrap" style={{gap: '64px'}}>
                        <div>
                            <p className="text-secondary fw-bold mb-0">Total minings <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} style={{fontSize: '13px', cursor: 'pointer'}} onClick={() => {
                            setSee(see === true ? false : true);
                            }}/></p>
                            <h2 className="fs-4 fw-bold mb-0">{(see === true)?getCurrencySymbol(user?.currency)+minbal * rate:'******'}</h2>
                        </div>
                        <div>
                            <p className="text-secondary fw-bold mb-0">Active minings:</p>
                            <h2 className="fs-4 fw-bold mb-0">{activemining.length}</h2>
                        </div>
                        <div>
                            <p className="text-secondary fw-bold mb-0">Closed minings:</p>
                            <h2 className="fs-4 fw-bold mb-0">{closedmining.length}</h2>
                        </div>
                    </div>
                    <div className="myBtn text-white" onClick={() => {toggleMiningBar()}} style={{fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgba(255, 255, 255, 0.05)'}}><FontAwesomeIcon icon={faClock} style={{fontSize: '14px'}} className="me-1"/> View minings</div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <h5 className="mb-0 fw-bold text-white mt-5 ms-2">Pools</h5>
              </div>
            </div>
          </main>
        </div>
        <div className={`notifybar ${miningBar ? "active" : null}`}>
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                    <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleMiningBar()}}/>
                    <p className="mb-0 fw-semibold ms-3 text-white">Mining History</p>
                </div>
                <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleMiningBar()}}/>
            </div>
            <div className="sidebar-navbar">
                <div className="d-flex align-items-center flex-column justify-content-center w-100 h-100" style={{gap: '16px', color: 'rgba(255, 255, 255, 0.65)'}}>
                    <svg style={{width: '40px', height: '40px'}} className="svg-icon" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.132 6.06h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14.352 2.5h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V4.7c0-1.76.44-2.2 2.22-2.2Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.132 17.56h10" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.352 14h5.56c1.78 0 2.22.44 2.22 2.2v4.11c0 1.76-.44 2.2-2.22 2.2h-5.56c-1.78 0-2.22-.44-2.22-2.2V16.2c0-1.76.44-2.2 2.22-2.2ZM22.132 15.5c0 3.87-3.13 7-7 7l1.05-1.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.05 4.1 3.738 7.414M3.732 4.1l3.314 3.314" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"></path></svg>
                    <p className=" mb-0 fw-semibold">No minings yet.</p>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Mining